export default {
  eventApplicants: process.env.BASE_URL + '/api/modules/group/user_list',
  signUp: process.env.BASE_URL + '/api/modules/group/submit',
  changeGroup: process.env.BASE_URL + '/api/modules/group/change_group',
  userStatus: process.env.BASE_URL + '/api/modules/group/user_status',
  groupStatus: process.env.BASE_URL + '/api/modules/group/group_info',
  transformCDNPath: process.env.BASE_URL + '/api/modules/group/return_url'
}